import React from 'react';
import './Vision_Mission.css';

const VisionMissionPage = () => {
  return (
    <div className="vision-mission-container">
      <div className="vision-mission-content">
        <header className="vision-mission-header">
          <h1 className="vision-mission-title">Cosmical Event Planners Pvt Ltd</h1>
          <div className="divider"></div>
          <h2 className="subtitle">Vision and Mission</h2>
        </header>

        <section className="vision-section">
          <h2 className="section-title">VISION</h2>
          <p className="section-text">
            Cosmical Event Planners envisions emerging as a premier partner for managing diverse events of various scales, both nationally and internationally, for our esteemed clients. Leveraging our dynamic team, effective strategies, and exceptional temperament, we are dedicated to delivering prompt, affordable, and top-notch services.
          </p>
          <p className="section-text">
            Renowned for our passion, creativity, and expertise, we envision a future where every event we curate is a masterpiece, leaving a lasting impact on attendees and setting new benchmarks for the industry.
          </p>
        </section>

        <section className="mission-section">
          <h2 className="section-title">MISSION</h2>
          <ul className="mission-list">
            <li>To provide a seamless and inspiring online experience for couples planning spiritual Hindu destination weddings.</li>
            <li>We empower couples to create unforgettable destination weddings that honor their heritage and traditions.</li>
            <li>We build long-lasting relationships with clients and partners by continuously innovating and improving our services.</li>
            <li>We transform visions into extraordinary realities, exceeding expectations to create lifelong memories.</li>
            <li>We aim to positively impact our community and environment through sustainable business practices.</li>
          </ul>
        </section>

        <p className="footer-text">Creating memorable experiences since 2020</p>
      </div>
    </div>
  );
};

export default VisionMissionPage;
